import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';

import { pausePlayback, resumePlayback } from '../api/client.js';
import { djViewQueryKey } from '../api/queryKeys.js';

import type { ChannelId, DjView, PartySlug } from '@mixwire/contracts';

type TransportVariables = {
  readonly slug: PartySlug;
  readonly channelId: ChannelId;
  readonly action: 'pause' | 'resume';
};

/**
 * One mutation for both directions rather than two, so the console cannot have a pause in flight
 * and a resume in flight at once — a single `isPending` is what disables the one button.
 */
export const useTransport = (): UseMutationResult<DjView, Error, TransportVariables> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ slug, channelId, action }: TransportVariables) =>
      action === 'pause' ? pausePlayback(slug, channelId) : resumePlayback(slug, channelId),
    onSuccess: (djView, { slug, channelId }) => {
      queryClient.setQueryData(djViewQueryKey(slug, channelId), djView);
    },
  });
};
